import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué es exactamente el Sistema de Tarot Terapéutico?',
  answer: 'Es una metodología estructurada que transforma el tarot de una herramienta predictiva a un puente de sanación emocional. Recibís manuales, guías de interpretación, protocolos de protección y fichas de seguimiento para dar un marco profesional y profundo a tus lecturas.'
}, {
  question: '¿Necesito tener conocimientos previos o un mazo de cartas?',
  answer: 'No es necesario. El sistema te guía desde cero en la simbología de los arcanos. Además, incluimos una guía práctica basada en el mazo Rider Waite para que puedas empezar a practicar de inmediato incluso si aún no tenés tus cartas físicas.'
}, {
  question: '¿Cómo recibo el material y los 4 bonos de regalo?',
  answer: 'El acceso es inmediato y de por vida. Una vez confirmado el pago, recibirás un correo con el enlace de descarga de todos los archivos (PDFs y materiales editables). Podés guardarlos en tu computadora, tablet o celular y consultarlos siempre que quieras.'
}, {
  question: '¿Es útil si ya tengo experiencia como tarotista?',
  answer: '¡Totalmente! Muchos profesionales lo eligen por la "Infraestructura Sistémica": las fichas de anamnesis, el diario de evolución y la biblioteca de 200 preguntas son herramientas que elevan el nivel de cualquier consulta, dándole un orden terapéutico que no se enseña en cursos tradicionales.'
}, {
  question: '¿En qué consiste el protocolo de protección energética?',
  answer: 'Es uno de nuestros materiales más valorados (Bono 04). Te enseña técnicas prácticas para limpiar tu espacio, proteger tu campo áurico y sostener la energía durante la sesión, evitando el agotamiento que suelen sentir los terapeutas al terminar sus lecturas.'
}, {
  question: '¿Qué pasa si el sistema no es lo que esperaba?',
  answer: 'Confiamos plenamente en la calidad de nuestro material. Por eso, contás con una garantía de satisfacción de 7 días. Si sentís que el sistema no aporta valor a tu práctica personal o profesional, podés solicitar el reembolso total de tu inversión.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-transparent relative overflow-hidden" data-id="element-273" data-mp="2ay92rnuzebkn">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none opacity-20" data-id="element-274" data-mp="38kg66ufjtxvf">
        <div className="absolute top-10 left-10 w-64 h-64 bg-purple-200 rounded-full blur-[100px]" data-id="element-275" data-mp="33npqi87np4aj" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-amber-100 rounded-full blur-[100px]" data-id="element-276" data-mp="2ym0ccjp50ai8" />
      </div>
      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-277" data-mp="2ulgj3r7opr1d">
        <div className="text-center mb-16" data-id="element-278" data-mp="1n8eqb7ekqp0x">
          <h2 className="text-4xl md:text-6xl font-bold text-purple-950 font-magical italic mb-4" data-id="element-279" data-mp="1n61ze4qu94bq">
            Preguntas <span className="text-purple-600" data-id="element-280" data-mp="1j8xlmg6z1vwt">Frecuentes</span>
          </h2>
          <p className="text-purple-600 font-black tracking-[0.2em] uppercase text-[10px]" data-id="element-281" data-mp="3uvrbxxqx27fr">
            Despejá tus dudas y comenzá hoy
          </p>
        </div>
        <div className="space-y-4" data-id="element-282" data-mp="7oyo0b7hkdgp">
          {faqs.map((faq, i) => <div key={i} className="group rounded-[2rem] overflow-hidden bg-white border border-purple-100 shadow-lg premium-shadow transition-all duration-300 hover:border-purple-200" data-id="element-283" data-mp="7ndt2kh9esib" data-mpi={i}>
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className={`w-full flex items-center justify-between p-6 md:p-8 text-left transition-all duration-300 ${openIndex === i ? 'bg-purple-50/50' : 'hover:bg-purple-50/30'}`} data-id="element-284" data-mp="hh4grn5kaywy">
                <span className="text-lg md:text-xl font-bold text-purple-950 font-magical italic pr-8" data-id="element-285" data-mp="vf1eimvr5bd7">
                  {faq.question}
                </span>
                <div className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${openIndex === i ? 'bg-purple-600 text-white rotate-180' : 'bg-purple-50 text-purple-400 group-hover:text-purple-600'}`} data-id="element-286" data-mp="2s9fquxtpfkd6">
                  <ChevronDown size={20} data-id="element-287" data-mp="1wvv3ncrxt0zm" />
                </div>
              </button>
              <AnimatePresence data-id="element-288" data-mp="2bufbn6vsb6zv">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-289" data-mp="2bs2u2utxuync">
                    <div className="px-6 md:px-8 pb-8" data-id="element-290" data-mp="1swct9axqs8b1">
                      <div className="pt-4 border-t border-purple-100/50 text-zinc-600 leading-relaxed text-base md:text-lg" data-id="element-291" data-mp="1sx4afgqle3hs">
                        {faq.answer}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-292" data-mp="37397vu3ken3h">
          <p className="text-zinc-400 text-sm italic" data-id="element-293" data-mp="372h8s9are78g">
            ¿Tenés otra consulta? Escribinos y te ayudamos a decidir.
          </p>
        </div>
      </div>
    </section>;
}